import { ShieldCheck, UserCheck, FileSignature, Truck } from "lucide-react";

export const slugify = (title) => title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

export const SERVICES = [
  {
    title: "Governance, Risk & Compliance Support",
    icon: ShieldCheck,
    short:
      "Compliance support, governance and operational structure, policy development, and Standard Operating Procedure creation that keep your business documented and ready.",
    items: [
      "Business compliance support",
      "Governance and operational structure",
      "Risk identification",
      "Compliance readiness",
      "Policy development",
      "Standard Operating Procedure creation",
      "Document organization and review",
      "Internal process development",
    ],
    notes: [
      "TSM Group CLE provides business compliance and operational support. Businesses remain responsible for determining and meeting requirements applicable to their organization and industry.",
    ],
  },
  {
    title: "Workforce & Employment Verification",
    icon: UserCheck,
    short:
      "I-9 Authorized Representative services, employee verification, workforce documentation, and onboarding support for employers.",
    items: [
      "I-9 verification support",
      "Authorized Representative services",
      "Employee verification services",
      "Workforce documentation support",
      "Background screening coordination",
      "Employment onboarding support",
    ],
    notes: [
      "Employers remain responsible for meeting applicable federal, state, and local employment requirements.",
    ],
  },
  {
    title: "Notary & Document Services",
    icon: FileSignature,
    short:
      "General, mobile, and remote online notarization, loan signing services, apostille support, and sensitive document notarization.",
    items: [
      "General notary services",
      "Mobile notary",
      "Remote online notarization",
      "Loan signing services",
      "Power of Attorney document notarization",
      "Estate document notarization",
      "Business document notarization",
      "I-9 Authorized Representative services",
      "Apostille support",
    ],
    notes: ["TSM Group CLE does not provide legal advice."],
  },
  {
    title: "Mobile Business Services",
    icon: Truck,
    short:
      "Onsite employer services, mobile notary, field inspections, and business support appointments — performed at your location or a designated site.",
    items: [
      "Onsite employer services",
      "Mobile notary services",
      "Field inspections",
      "Document verification",
      "Business support appointments",
    ],
    notes: ["Mobile services may be available depending on service type and location."],
  },
].map((s) => ({ ...s, slug: slugify(s.title) }));

// Services that moved into the TSM4 product suite — legacy URLs redirect to their new pages.
export const TSM4_REDIRECTS = {
  "drug-alcohol-testing-services": "/tsm4/drug-testing",
  "fingerprinting-background-services": "/tsm4/fingerprinting",
};

export const getService = (slug) => SERVICES.find((s) => s.slug === slug);
